/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import { environment } from "./Environment";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        //clientId: "51877559-f54a-4822-b484-2100c7f026d5",
        clientId: environment.env == "prod" ? "16e10010-d32d-4228-a117-e1b5ea3c6d73" : environment.env=="qa"?"c0fa54a1-f9b6-416e-bedc-665dfbe9dcb8":"51877559-f54a-4822-b484-2100c7f026d5",
        authority: environment.env == "qa"?"https://login.microsoftonline.com/29b4f1e5-52d8-4562-940a-ff00c2407410":"https://login.microsoftonline.com/e6fd9f9f-6c49-4254-b8e8-90fba073cceb",
        redirectUri: environment.env == "development" ? "http://localhost:5000/" : environment.env == "qa" ? "https://cipla-qa.cimmra.com/sso" : environment.env == "uat" ? "https://invoicing-uat.cipla.com/sso/" : "https://invoicing.cipla.com/sso/"
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
